import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";

import { HttpInterceptorFn } from '@angular/common/http';

export const authServiceInterceptor: HttpInterceptorFn = (req, next) => {
  let token = localStorage.getItem('token');

  let tokenizedReq = req.clone({
    setHeaders: {
      Authorization: "Bearer " + token
    }
  })

  if (!req.headers.has('x-none')) {
    tokenizedReq.headers.append("Content-Type", "application/json");
  }

  return next(tokenizedReq);
};

export class HttpTokenInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token = localStorage.getItem('token');

    let tokenizedReq = req.clone({
      setHeaders: {
        Authorization: "Bearer " + token
      }
    })

    if (!req.headers.has('x-none')) {
      tokenizedReq.headers.append("Content-Type", "application/json");
    }

    return next.handle(tokenizedReq)
  }

}
